class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/otp/report'
			},
			statusChange: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/update/redeem/:id'
			},
			optReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/redeem/stats'
			},

			//Creating the fetch data path for otp-logs 
			otplogs: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/otp-logs'
			}
		};
	}
}

export default new APIS();
